import { render, staticRenderFns } from "./TokenSettings.vue?vue&type=template&id=3fd38338"
import script from "./TokenSettings.vue?vue&type=script&lang=js"
export * from "./TokenSettings.vue?vue&type=script&lang=js"
import style0 from "./TokenSettings.vue?vue&type=style&index=0&id=3fd38338&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports